import React from 'react';
import EsDeskMonitor from './EsDeskMonitor';
// VENUS — overnight ES LONG (pullback-in-uptrend, reads SATURN). Grade B.
export default function VenusMonitor() { return <EsDeskMonitor system="venus" accent="#0d9488" />; }
